import {
  Button,
  Card,
  CardContent,
  createMuiTheme,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
  MuiThemeProvider,
  Paper,
  Popover,
  Tooltip,
  Typography,
  withStyles
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Close } from '@material-ui/icons';
import fmiLogo from 'assets/img/fmi-small.png';
import hollardLogo from 'assets/img/hollard.png';
import libertyLogo from 'assets/img/liberty-small.jpg';
import momentumLogo from 'assets/img/momentum-small.jpg';
import sanlamLogo from 'assets/img/sanlam-small.png';
import ppsLogo from 'assets/img/pps.png';
import oldmutualLogo from 'assets/img/oldmutual.png';
import { GetUserId, GetUserToken } from 'helpers/UserHelper';
import { getTargets } from 'queries/Target';
import React from 'react';
import { graphql } from 'react-apollo';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { closeProgress, removeTask } from 'reducers/TasksReducer';
import store from 'store';
import TaskManager from './task/TaskManager';

const logoMap = {
  fmi: fmiLogo,
  bidvest: fmiLogo,
  liberty: libertyLogo,
  momentum: momentumLogo,
  sanlam: sanlamLogo,
  hollard: hollardLogo,
  pps: ppsLogo,
  "old mutual": oldmutualLogo 
};

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#bb00ff'
    },
    secondary: {
      main: '#4caf50'
    }
  }
});

const CustomHeadingLabel = props => (
  <div
    style={{
      position: 'absolute',
      top: '-8px',
      left: '10px',
      backgroundColor: '#e0e0e0',
      borderRadius: '10px',
      padding: '1px 18px'
    }}
  >
    <Typography variant='subheading'>
      <strong>{props.label}</strong>
    </Typography>
  </div>
);

const styles = {
  root: {
    width: '400px'
  },
  linearProgress: {
    width: '100%',
    backgroundColor: '#dadada'
  },
  listItem: {
    width: '350px'
  },
  Description: {
    color: 'grey'
  },
  logo: {
    width: '32px',
    height: 'auto'
  }
};

class TaskList extends React.Component {
  state = {
    errorDialogOpen: false,
    errorText: null,
    errorTarget: null,
    errorDesc: null
  };

  closeErrorDialog = () => {
    this.setState({ errorDialogOpen: false });
  };
  openErrorDialog = (errorText, targetName, desc) => {
    this.setState({
      errorDialogOpen: true,
      errorText,
      errorTarget: targetName,
      errorDesc: desc
    });
  };

  navigateResults(guid) {
    this.props.history.push({
      pathname: '/app/quoteresult',
      search: `guid=${guid}`
    });
  }

  makeButton(currentTask) {
    return currentTask.jobs.filter(x => x.progress === 100).length > 0 ? (
      <Button
        variant='outlined'
        className='outlinedButton'
        style={{ color: '#6c5cab', marginLeft: '15px', marginBottom: '5px' }}
        onClick={() => this.navigateResults(currentTask.guid)}
      >
        View
      </Button>
    ) : null;
  }

  runningTasks() {
    const { classes, currentTasks } = this.props;

    return (
      <div
        style={{
          backgroundColor: '#fff',
          position: 'relative',
          minHeight: 95,
          padding: '18px 10px 15px'
        }}
      >
        <CustomHeadingLabel label='Quotes In Progress' />

        {currentTasks.map(task => {
          let taskJobs = [...task.jobs];

          taskJobs.sort(function(a, b) {
            var textA = a.targetName.toUpperCase();
            var textB = b.targetName.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
          });

          task.jobs = taskJobs;

          const taskDesc = task.meta ? task.meta.desc : task.jobs[0].client;

          return (
            <Card
              style={{
                marginTop: '18px',
                border: '1px solid #cecece',
                borderRadius: '10px'
              }}
            >
              <CardContent
                style={{
                  textAlign: 'center',
                  padding: 0
                }}
              >
                <Grid container>
                  <Grid
                    item
                    xs={11}
                    sm={11}
                    md={11}
                    style={{ backgroundColor: '#cecece4f' }}
                  >
                    <h4 style={{ margin: '0' }}>
                      <b style={{ paddingLeft: 15 }}>{taskDesc}</b>
                    </h4>
                  </Grid>
                  <Tooltip title='Close Quote'>
                    <Grid
                      item
                      xs={1}
                      sm={1}
                      md={1}
                      style={{
                        borderBottom: '1px solid #cecece4f',
                        cursor: 'pointer'
                      }}
                      onClick={e => {
                        global.messager.publish('/clearTask', {
                          guid: task.guid,
                          uid: GetUserId()
                        });
                        store.dispatch(removeTask({ guid: task.guid }));
                      }}
                    >
                      <Close style={{ fontSize: '1.34em' }} />
                    </Grid>
                  </Tooltip>
                </Grid>

                {task.jobs.map(job => {
                  const logoSrc = logoMap[job.targetName.toLowerCase()];
                  return job.error === 0 ? (
                    <List>
                      <ListItem>
                        <img
                          src={logoSrc}
                          alt={job.targetName}
                          className={classes.logo}
                        />
                        <ListItemText
                          primary={job.targetName}
                          className={classes.listItem}
                        />
                      </ListItem>
                      <ListItem>
                        <LinearProgress
                          className={classes.linearProgress}
                          color={job.progress === 100 ? 'secondary' : 'primary'}
                          variant='determinate'
                          value={job.progress}
                        />
                      </ListItem>
                    </List>
                  ) : (
                    <React.Fragment>
                      <List>
                        <ListItem>
                          <img
                            src={logoSrc}
                            alt={job.targetName}
                            className={classes.logo}
                          />
                          <ListItemText
                            primary={job.targetName}
                            className={classes.listItem}
                          />
                        </ListItem>
                        <ListItem
                          style={{
                            padding: '0px 27px',
                            position: 'relative',
                            top: '-5px'
                          }}
                        >
                          {job.error.includes('TextError:') ? (
                            <Typography
                              className='typographyLink'
                              onClick={e => {
                                this.openErrorDialog(
                                  job.error.replace('TextError:', ''),
                                  job.targetName,
                                  taskDesc
                                );
                              }}
                              style={{ cursor: 'pointer' }}
                            >
                              Error: Click to view
                            </Typography>
                          ) : (
                            <a href={job.error} target='_blank'>
                              Error: Click to view
                            </a>
                          )}
                        </ListItem>
                      </List>
                    </React.Fragment>
                  );
                })}

                {this.makeButton(task)}
              </CardContent>
            </Card>
          );
        })}
      </div>
    );
  }

  pendingTasks = () => {
    const { pendingTasks } = this.props;
    return (
      <div
        style={{
          backgroundColor: '#fff',
          position: 'relative',
          minHeight: 95,
          padding: '18px 0px 15px 0px'
        }}
      >
        <CustomHeadingLabel label='Pending Quotes' />
        <div style={{ marginBottom: 25 }} />
        {pendingTasks.map(task => (
          <div style={{ textAlign: 'center' }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                margin: '15px',
                borderBottom: '1px solid #cecece'
              }}
            >
              <h4>
                <b>{task.description}</b>
              </h4>
              <CircularProgress
                style={{
                  width: '20px',
                  height: '20px',
                  top: '10px',
                  right: '15px',
                  position: 'relative'
                }}
              />
            </div>
          </div>
        ))}
      </div>
    );
  };

  render() {
    if (!global.taskmanager && GetUserToken() !== '') {
      global.taskmanager = new TaskManager();
      global.taskmanager.start();
      if (!this.props.initialFetchDone) global.taskmanager.initialFetch();
    }
    this.taskmanager = global.taskmanager;

    const { classes, currentTasks, pendingTasks } = this.props;

    const noTasksExist = currentTasks.length === 0 && pendingTasks.length === 0;

    return (
      <MuiThemeProvider theme={theme}>
        <Popover
          open={this.props.tasksOpen}
          onClose={() => store.dispatch(closeProgress())}
          anchorReference={'anchorEl'}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center'
          }}
        >
          <Paper
            className={classes.root}
            style={{
              padding: noTasksExist ? '15px 15px 15px' : '30px 0px 15px'
            }}
          >
            {noTasksExist ? (
              <Typography>No in-progress or pending quotes yet.</Typography>
            ) : (
              <React.Fragment>
                {currentTasks.length > 0 ? this.runningTasks() : null}
                <div style={{ marginBottom: 20 }} />
                {pendingTasks.length > 0 ? this.pendingTasks() : null}
              </React.Fragment>
            )}
          </Paper>
        </Popover>
        <Dialog
          open={this.state.errorDialogOpen}
          onClose={() => this.closeErrorDialog()}
          aria-labelledby='form-dialog-title'
          className='centerFixedDialog'
        >
          <DialogTitle id='form-dialog-title' style={{ textAlign: 'center' }}>
            {`${this.state.errorTarget} Quote Error - ${this.state.errorDesc}`}
          </DialogTitle>

          <DialogContent>
            <Typography>{this.state.errorText}</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.closeErrorDialog()} color='primary'>
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </MuiThemeProvider>
    );
  }
}

TaskList = withStyles(styles)(TaskList);
TaskList = withRouter(TaskList);
TaskList = graphql(getTargets)(TaskList);

function mapStateToProps(state) {
  return {
    tasksOpen: state.tasks.progressOpen,
    currentTasks: state.tasks.currentTasks,
    pendingTasks: state.tasks.pendingTasks,
    initialFetchDone: state.tasks.initialFetchDone
  };
}

TaskList = connect(mapStateToProps)(TaskList);

export default TaskList;



// WEBPACK FOOTER //
// ./src/components/SqTasks/TaskList.jsx